import IOApi from '@/api/IOApi'

export class GetBPList {
  static async fetchIOListAll({ advertiserId }) {
    try {
      const { items } = await IOApi.fetchIOList({ advertiserId, period: 'all' })
      return items.filter(item => item.billingPeriods.length > 0)
    } catch (e) {
      throw new Error('in BudgetProgressReport')
    }
  }
}

export const getBPList = ({ advertiserId }) =>
  GetBPList.fetchIOListAll({ advertiserId })
